<template>
    <button
        class="btn btn-primary btn-sm"
        data-bs-toggle="collapse"
        :data-bs-target="`#${target}`"
        :aria-expanded="showAll"
        :aria-controls="target"
        type="button"
    >
        <Icon icon="chevron-down" class="icon-toggle" />
    </button>
</template>

<script>
    export default {
        name: 'ButtonCollapse',
        props: {
            showAll: {
                type: Boolean,
                default: false,
            },
            target: {
                type: String,
                required: true,
            },
        },
    }
</script>
